export default {
  nav: {
    title: '檔案管理',
    manage: '管理',
    done: '完成',
  },
  search: {
    placeholder: '搜索檔案',
    suggestion: '搜索建議',
  },
  categories: {
    all: '全部',
    self: '自己',
    partner: '伴侶',
    child: '孩子',
    parent: '父母',
    friend: '朋友',
    customer: '客戶',
    colleague: '同事',
    other: '其他',
  },
  profileList: {
    male: '男',
    female: '女',
    current: '當前',
    example: '示例',
    solarLabel: '陽曆：',
    lunarLabel: '農曆：',
    birthdayInfo: '生日信息',
    destinyInfo: '命理乾坤',
    noResults: '暫無相關檔案',
    setCurrent: '設為當前',
    edit: '編輯',
    delete: '刪除',
    deleteConfirm: '確認刪除',
    deleteMessage: '確定要刪除「{{name}}」的檔案嗎？此操作無法復原。',
    cancel: '取消',
    dragHint: '長按可拖拽排序',
  },
  manageBar: {
    selectAll: '全選',
    deselectAll: '取消全選',
    selectedCount: '已選 {{count}} 個',
    delete: '刪除',
  },
  batchDelete: {
    title: '確認刪除 {{count}} 個檔案？',
    message: '此操作無法復原，請謹慎操作',
    cancel: '取消',
    confirm: '確認刪除',
  },
  operationHint: {
    manage: '勾選檔案後可批量刪除',
    normal: '點擊左側圓圈可設為本次使用的命主',
  },
  destinyModal: {
    subtitle: '基於生命數字的靈性解析',
    energyTitle: '先天能量分析',
    analysisTitle: '命盤解析',
    nodes: {
      talent: '天賦',
      personality: '個性',
      destiny: '命運',
      ability: '才能',
      karma: '業力',
    },
    nodeSubs: {
      talent: '靈性天賦',
      personality: '外在表現',
      destiny: '核心使命',
      ability: '潛在才能',
      karma: '今生課題',
    },
    energyBars: {
      love: '愛情運',
      career: '事業運',
      wealth: '財富運',
      overall: '綜合運',
    },
    analysis: {
      para1_prefix: '命運數字 ',
      para1_mid: ' 象徵自由、變化與冒險，此生使命在於突破束縛，勇於探索未知。天賦數字 ',
      para1_suffix: ' 代表靈性洞察與深度思考，擁有超凡的直覺力。',
      para2_prefix: '才能數字 ',
      para2_mid: ' 顯示強大的人道主義精神，業力數字 ',
      para2_suffix: ' 提示今生需要學習耐心與合作。',
      careerTip: '事業運旺盛（84%），適合複雜環境中把握機遇、引領變革',
    },
  },
  birthdayModal: {
    birthTime: '出生時間',
    birthPlace: '出生地區',
  },
  addButton: {
    add: '新增',
    profile: '檔案',
  },
  manageMenu: {
    sort: '排序檔案',
    delete: '刪除檔案',
    share: '分享檔案',
  },
  addModal: {
    title: '新增檔案',
    editTitle: '編輯檔案',
    selectRelation: '選擇關係',
    nameLabel: '姓名',
    namePlaceholder: '請輸入姓名',
    genderLabel: '性別',
    male: '男',
    female: '女',
    solar: '陽曆',
    lunar: '農曆',
    fourPillars: '四柱',
    birthTime: '出生時間',
    birthPlace: '出生地區',
    group: '分組',
    allGroup: '全部',
    other: '其他',
    required: '必填',
    save: '保存',
    nextButton: '下一步：填寫生日信息',
    cancel: '取消',
    selectPlaceholder: '請選擇',
    trueSolarTime: '真太陽時',
    coordLabel: '地理經緯',
    currentResidence: '現居住地',
    birthCoordLabel: '出生地經緯',
    currentResidenceCoordLabel: '現居住地經緯',
  },
  birthTimePicker: {
    title: '出生時間',
    today: '今',
    confirm: '確定',
    year: '年',
    month: '月',
    day: '日',
    hour: '時',
    minute: '分',
    shichen: '時辰',
    unknown: '未知',
    lunarYearUnit: '年',
    lunarHourUnit: '時',
    leapPrefix: '閏',
    lunarMonths: ['正月','二月','三月','四月','五月','六月','七月','八月','九月','十月','冬月','臘月'],
    lunarDays: ['初一','初二','初三','初四','初五','初六','初七','初八','初九','初十','十一','十二','十三','十四','十五','十六','十七','十八','十九','二十','廿一','廿二','廿三','廿四','廿五','廿六','廿七','廿八','廿九','三十'],
    yearPillar: '年柱',
    monthPillar: '月柱',
    dayPillar: '日柱',
    hourPillar: '時柱',
    searchRange: '查找範圍',
    clearBtn: '清除',
    autoLabel: '自動',
    noteFourPillars: '注：出生時間精確到準確時辰，更有利于報告的效果；未知出生時辰，可默認午時（地支午）。',
    noteTime: '注：出生時間精確到準確時辰，更有利于報告的效果；未知出生時辰，可默認12:00。',
    pillarHint: '點擊圓圈選擇天干或地支',
  },
  quickAdd: {
    optional: '可選填',
    preview: '命主預覽',
    noName: '（姓名未填）',
    zodiacPrefix: '屬',
    saveToProfiles: '保存到檔案管理',
    saveDesc: '將加入檔案並設為當前命主',
    tempDesc: '僅用於本次測算，不保存到檔案',
    saveAndUse: '保存並使用此命主',
    tempOnly: '僅用於本次測算',
    dateFormat: '{{y}}年{{m}}月{{d}}日 {{hour}}時',
    zodiac_rat: '鼠',
    zodiac_ox: '牛',
    zodiac_tiger: '虎',
    zodiac_rabbit: '兔',
    zodiac_dragon: '龍',
    zodiac_snake: '蛇',
    zodiac_horse: '馬',
    zodiac_goat: '羊',
    zodiac_monkey: '猴',
    zodiac_rooster: '雞',
    zodiac_dog: '狗',
    zodiac_pig: '豬',
  },
  birthPlacePicker: {
    title: '出生地區',
    domestic: '中國',
    overseas: '海外',
    confirm: '確定',
    province: '省/直轄市',
    city: '市/區',
    district: '區/縣',
    region: '區位',
    country: '國家',
    area: '地區',
    unknownPlace: '未知地',
    beijingTime: '北京時間',
    unknownDistrict: '--',
    unknownArea: '--',
    coordNorth: '北緯',
    coordSouth: '南緯',
    coordEast: '東經',
    coordWest: '西經',
    searchPlaceholder: '搜尋城市或地區',
    cancel: '取消',
    noResult: '未找到相關地區',
    sameAsBirth: '與出生地一致',
  },
};
